export default __webpack_public_path__ + "static/media/Circlet of the Spheres.f1cb71b8.jpg";